
import {Prop} from "vue-property-decorator"
import Component from "vue-class-component"
import {MetricAggregated} from "@/cube/metric-data/MetricStore"
import * as _ from "lodash"
import AnimatedNumber from "@/ui/AnimatedNumber.vue"
import {WithAnalyticsNavigation} from "@/superannuation/WithAnalyticsNavigation"

@Component({components: {AnimatedNumber}})
export default class CircularProgressBarWidget extends WithAnalyticsNavigation {
  @Prop()
  metricData: MetricAggregated

  @Prop({default: false})
  reverse: boolean

  @Prop({default: 25})
  attentionThreshold: number

  @Prop({default: false})
  showCount: boolean

  get progressColor() {
    return this.reverse ? "negative" : "alt-1-color"
  }

  private get isShowAttention() {
    return this.reverse
      ? this.amountPercent >= this.attentionThreshold
      : this.amountPercent <= this.attentionThreshold
  }

  get amountPercent() {
    return _.round((this.metricData.end?.amountPercent ?? 0) * 100)
  }

  get amount() {
    return this.metricData.end?.amount
  }

  get title() {
    return this.metricData.title
  }
}
